module.exports = __webpack_public_path__ + "img/right_arrow_icon.69884586.svg";